import { Row, Col } from 'react-bootstrap';

const ServiceLeadAdmin = () => {
    return (
        <Row>
            <Col xs={12} md={6} className="p-0">
                <Row>
                    <Col xs={12}>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
export default ServiceLeadAdmin;
